'use client'

import { memo } from 'react'

import CartButton from './CartButton'
import CartButtonMobile from './CartButtonMobile'

import styles from './CartDrawerControls.module.scss'

const CartDrawerControls = memo(
  ({
    onClick,
    ecoVariant,
    open
  }: {
    onClick: () => void
    ecoVariant?: boolean
    open: boolean
  }) => (
    <>
      <div className={styles.webContent} style={{ width: 'unset' }}>
        <CartButton onClick={onClick} isEcoVariant={ecoVariant} open={open} />
      </div>
      <div className={styles.tabletContent} style={{ width: 'unset' }}>
        <CartButtonMobile onClick={onClick} open={open} />
      </div>
    </>
  )
)

export default CartDrawerControls
